// 导入vue
import Vue from 'vue'

// 引入组件
import { Button, Icon, Popup, Cell, CellGroup, Field , Picker  } from 'vant'

// 使用组件
Vue.use(Button)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Cell) 
Vue.use(CellGroup);
Vue.use(Field);
Vue.use(Picker);